export default __webpack_public_path__ + "static/media/SVGChat.f6df6673.svg";